import type { FC } from "react";

import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { Button } from "@jti/core-components/components/Button";
import { Dialog } from "@jti/ui/components/Dialog";
import { Typography } from "@jti/ui/components/Typography";

import styles from "./PackCodeDialog.module.scss";

export type PackCodeDialogProps = {
  showConfirmationDialog: boolean;
  onClose: () => void;
  confirmationTitle: string;
  earningMessage: string;
  historyMessage: string;
  historyMessageLink: string;
  limitTextReached: string;
  limitReached: boolean;
  closeButtonText: string;
};

export const PackCodeDialog: FC<PackCodeDialogProps> = ({
  showConfirmationDialog,
  onClose,
  confirmationTitle,
  earningMessage,
  historyMessage,
  historyMessageLink,
  limitTextReached,
  limitReached,
  closeButtonText,
}) => {
  return (
    <Dialog className={styles.container} isOpened={showConfirmationDialog} onClose={onClose}>
      <section className={styles.dialog}>
        <UiCheckCircleIcon width="32px" height="32px" className={styles.icon} />
        <Typography variant="h1" weight="light" className={styles.title} dataTestId="packDialogTitle">
          {confirmationTitle}
        </Typography>
        <Typography variant="body2" weight="light" className={styles.text} dataTestId="packDialogText">
          {earningMessage}
        </Typography>
        <a href={historyMessageLink} className={styles.history}>
          <Typography variant="body2" weight="light" dataTestId="packDialogHistoryMessage">
            {historyMessage}
          </Typography>
        </a>
        {limitReached && (
          <Typography variant="body2" weight="light" className={styles.text} dataTestId="packDialogLimitText">
            {limitTextReached}
          </Typography>
        )}
        <Button variant="primary" onClick={onClose} className={styles.button}>
          {closeButtonText}
        </Button>
      </section>
    </Dialog>
  );
};
